import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const ErrorPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Error message can be passed via location.state or fallback to a default
  const message = (location.state && (location.state as any).message) || 'Oops! Something went wrong on our end.';

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f6fa">
      <Box p={4} bgcolor="#fff3cd" borderRadius={2} boxShadow={3} border="1px solid #ffeeba" maxWidth={400}>
        <Typography variant="h3" color="#856404" align="center" gutterBottom>
          Uh-oh! 🚧
        </Typography>
        <Typography variant="h6" color="#856404" align="center" gutterBottom>
          {message}
        </Typography>
        <Typography variant="body1" color="#856404" align="center" gutterBottom>
          Don't worry, it's not you — it's us!<br />
          Please try refreshing the page, or click below to return to the home page.<br />
          If the problem persists, feel free to contact support.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/')} sx={{ mt: 2 }}>Return Home</Button>
      </Box>
      <Footer />
    </Box>
  );
};

export default ErrorPage; 